import moment from 'moment';
import {
  NEW_USER_REFERRAL_WINDOW_TIME,
  MAX_LENGTH_REFERRAL_CODE,
  MIN_LENGTH_REFERRAL_CODE,
  BLACKLIST_CODE_PREFIX,
} from '@src/constants/referral';
import route from '@src/constants/route';

const hasBlacklistedPrefix = (referralCode) => {
  const lowercaseCode = referralCode.toLowerCase();
  return BLACKLIST_CODE_PREFIX.some((prefix) =>
    lowercaseCode.startsWith(prefix.toLowerCase()),
  );
};

const formatBlacklistedPrefix = (prefixes) => prefixes.join(', ');

export const checkUserEligibility = (user) => {
  // Check if user account creation date has exceed more than window time by day
  const exceededWindowTime = moment(user.createdAt).isBefore(
    moment().subtract(NEW_USER_REFERRAL_WINDOW_TIME, 'day'),
  );
  const hasAlreadyReferred = user?.referral?.referrerId;

  return !exceededWindowTime && !hasAlreadyReferred;
};

export const getReferralContent = (code, link, refereeReward) =>
  `Bạn đang tìm một giải pháp chuyển văn bản thành giọng nói nhanh, chuẩn và tự nhiên? Mình đang dùng Vbee và rất ấn tượng.\n\nĐặc biệt, khi đăng ký qua link sau, bạn sẽ nhận ngay ${refereeReward} điểm miễn phí ngày đầu.\n${link}\nHoặc nhập mã giới thiệu này sau khi tạo tài khoản: ${code}\n\nHãy trải nghiệm và đánh giá nhé.`;

export const getReferralCharacterReward = ({
  points,
  redeemedCharsThisMonth,
  referralConfig = {},
}) => {
  if (!points || points < 0) return 0;

  const { charsPerPoint, maxAllowedRedeemCharactersPerMonth } = referralConfig;

  const maxRewardCharacter = points * charsPerPoint;
  const maxAllowedRedeemCharacters =
    maxAllowedRedeemCharactersPerMonth - redeemedCharsThisMonth;
  return Math.min(maxRewardCharacter, maxAllowedRedeemCharacters);
};

export const getValidateReferralCodeError = (code) => {
  const isValidCharacters = /^[A-Za-z0-9_-]+$/.test(code);
  const isTooShort = code.length < MIN_LENGTH_REFERRAL_CODE;
  const isTooLong = code.length > MAX_LENGTH_REFERRAL_CODE;
  const hasSpace = /\s/.test(code);
  const isBlacklistedPrefix = hasBlacklistedPrefix(code);

  const error = [
    {
      condition: isTooShort,
      key: 'referralCodeMinLength',
      params: { minLength: MIN_LENGTH_REFERRAL_CODE },
    },
    { condition: hasSpace, key: 'referralCodeSpace' },
    {
      condition: !isValidCharacters,
      key: 'referralCodeInvalidCharacters',
    },
    {
      condition: isTooLong,
      key: 'referralCodeMaxLength',
      params: { maxLength: MAX_LENGTH_REFERRAL_CODE },
    },
    {
      condition: isBlacklistedPrefix,
      key: 'invalidReferralCodePrefix',
      params: { prefixes: formatBlacklistedPrefix(BLACKLIST_CODE_PREFIX) },
    },
  ].find((e) => e.condition);

  return {
    key: error?.key,
    params: error?.params,
  };
};

export const calculateReferralStats = (referral, charsPerPoint) => {
  const earnedPoints = referral?.earnedPoints || 0;
  if (earnedPoints > 0) {
    const spentPoints = referral?.spentPoints || 0;
    const totalUsers = referral?.referralSuccessCount || 0;

    return {
      totalUsers,
      claimedChars: spentPoints * charsPerPoint,
      unclaimedChars: charsPerPoint * (earnedPoints - spentPoints),
    };
  }

  return {
    totalUsers: 0,
    claimedChars: 0,
    unclaimedChars: 0,
  };
};

export const extractReferralCodeFromUrl = (url) => {
  const urlObj = new URL(url);
  const { pathname } = urlObj;
  const referralCode = pathname.split('/').pop();
  return referralCode;
};

export const getUrlRedeemCode = ({
  packageCode,
  credits,
  devices,
  voiceClonings,
  redeemCode,
  creditsPerCycle,
}) => {
  const url = new URLSearchParams();
  url.set('package', packageCode);
  url.set('redeemCode', redeemCode);
  if (credits) url.set('credits', credits);
  if (devices) url.set('devices', devices);
  if (voiceClonings) url.set('voiceClonings', voiceClonings);
  if (creditsPerCycle) url.set('creditsPerCycle', creditsPerCycle);
  return `${route.PAYMENT}?${url.toString()}`;
};
